export const Interpolation = ({ children }: Record<string, unknown>) => <>{children}</>;
